import { ProjectActivity, ProjectActivityType } from "services/project-activities.service";

export function pad2(n: number) {
  return String(n).padStart(2, "0");
}

export function toLocalDateParts(d = new Date()) {
  return {
    date: `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`,
    time: `${pad2(d.getHours())}:${pad2(d.getMinutes())}`,
  };
}

export function toYmd(value: Date | null): string {
  if (!value) return "";
  return value.toISOString().split("T")[0];
}

export function combineLocal(date: string, time: string): number | null {
  if (!date) return null;
  const t = time || "00:00";
  const d = new Date(`${date}T${t}:00`);
  if (Number.isNaN(d.getTime())) return null;
  return d.getTime();
}

export function partsFromEpoch(ts: number | null | undefined) {
  if (!ts) return { date: "", time: "00:00" };
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return { date: "", time: "00:00" };
  return toLocalDateParts(d);
}

export type ActivityFormState = {
  title: string;
  activityType: ProjectActivityType;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  priority: "" | "LOW" | "MEDIUM" | "HIGH";
  note: string;
  location: string;
  videoCallUrl: string;
  showExtras: boolean;
  availability: "BUSY" | "FREE";
  assignedTo: string | null;
  isDone: boolean;
};

export function activityToFormState(activity: ProjectActivity): ActivityFormState {
  const start = partsFromEpoch(activity.startAt);
  const end = partsFromEpoch(activity.endAt);
  return {
    title: activity.title || "",
    activityType: activity.activityType,
    startDate: start.date,
    startTime: start.time,
    endDate: end.date || start.date,
    endTime: end.time,
    priority: activity.priority || "",
    note: activity.note || "",
    location: activity.location || "",
    videoCallUrl: activity.videoCallUrl || "",
    showExtras: Boolean(activity.location || activity.videoCallUrl),
    availability: activity.availability || "BUSY",
    assignedTo: activity.assignedTo?.id || null,
    isDone: Boolean(activity.isDone),
  };
}
